// src/Pages/Booking.jsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Booking.css";
import AboutSection from "../../Components/TopHeader/topheader";

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

const SERVICES = {
  timerectification: {
    label: "Time Rectification",
    originalPrice: 3000,
    offerPrice: 2100,
  },
  LoveCompatibility:{
        label: "Love Compatibility",
    originalPrice: 3000,
    offerPrice: 2100,
  },
  kundlianalysis: { label: "Full Kundli Analysis (30 MINS)", originalPrice: 1200, offerPrice: 770 },
  kundlianalysis1h: { label: "Full Kundli Analysis (1 HR)", originalPrice: 2200, offerPrice: 1540 },


  lovelifeconsultation: { label: "Relationship & Marriage Consultation (30 MINS)", originalPrice: 1400, offerPrice: 560 },
  lovelifeconsultation1h: { label: "Relationship & Marriage Consultation (1 Hr)", originalPrice: 2100, offerPrice: 1120 },
  lovelifeconsultationurgent: { label: "Relationship & Marriage Consultation (30 MINS urgent)", originalPrice: 1400, offerPrice: 896 },
  lovelifeconsultation1hurgent: { label: "Relationship & Marriage Consultation (1 Hr urgent)", originalPrice: 2100, offerPrice: 1400 },


 kundlianalysisurgent: { label: "Full Kundli Analysis (30 MINS Urgent)", originalPrice: 1700, offerPrice: 1232 },
kundlianalysis1hurgent: { label: "Full Kundli Analysis (1 HR Urgent)", originalPrice: 2700, offerPrice: 1925 },

careerconsultationurgent: { label: "Career Guidance (30 MINS Urgent)", originalPrice: 1800, offerPrice: 896 },
careerconsultation1hurgent: { label: "Career Guidance (1 HR Urgent)", originalPrice: 2700, offerPrice: 1400 },

  careerconsultation: { label: "Career Guidance (30 MINS)", originalPrice: 1300, offerPrice: 560 },
  careerconsultation1h: { label: "Career Guidance (1 HR)", originalPrice: 2200, offerPrice: 1120 },
  Quickconsultation: { label: "Quick Consultation (10 MINS)", originalPrice: 800, offerPrice: 350 },
  Quickconsultationurgent: { label: "Quick Consultation (10 MINS urgent)", originalPrice: 800, offerPrice: 560 },
  // consultationcall: { label: "Consultation Call (30 MINS)", originalPrice: 1000, offerPrice: 700 },
  // consultationcall1h: { label: "Consultation Call (1 HR)", originalPrice: 1500, offerPrice: 1050 },
  sampletest:{label:"sample testing of payment" , originalPrice:999 , offerPrice:1},
};

const BACKEND_URL = "https://cosmicalcalculatorbackend.onrender.com";
// const BACKEND_URL = "http://localhost:5000";

export default function AppointmentForm() {
  const location = useLocation();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    service: "",
    
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
  if (location.state?.selectedService) {
    const { selectedService, duration, mode } = location.state;

    // Build the service key dynamically
    let serviceKey = selectedService;

    // Handle duration (1 Hour versions)
    if (duration === "1 Hour") {
      serviceKey += "1h";
    }

    // Handle urgent variants if they exist in SERVICES
    if (mode === "Urgent" && SERVICES[`${serviceKey}urgent`]) {
      serviceKey += "urgent";
    }

    // Update form with the resolved key
    setForm((f) => ({ ...f, service: serviceKey }));
  }
}, [location.state]);


  function handleChange(e) {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  }

  const selectedServicePrice =
    form.service && SERVICES[form.service] ? SERVICES[form.service].offerPrice : 0;

async function handlePay(e) {
  e.preventDefault();
  setMessage(null);

  if (!form.firstName || !form.lastName || !form.email || !form.phone || !form.service) {
    setMessage({ type: "error", text: "Please fill all fields properly." });
    return;
  }

  setLoading(true);

  try {
    const createResp = await fetch(`${BACKEND_URL}/create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        form,
        service: SERVICES[form.service].label,
        amount: selectedServicePrice,
      }),
    });

    const data = await createResp.json();
    if (!createResp.ok) {
      setMessage({ type: "error", text: data.error || "Failed to create order." });
      setLoading(false);
      return;
    }

    // ✅ Create and submit hidden PayU form
    const formEl = document.createElement("form");
    formEl.method = "POST";
    formEl.action = data.action;

    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      formEl.appendChild(input);
    });

    document.body.appendChild(formEl);
    formEl.submit();
  } catch (err) {
    console.error(err);
    setMessage({ type: "error", text: "Something went wrong. Try again." });
    setLoading(false);
  }
}



  return (
    <section className="bookingpage-appointment-wrap">
      <AboutSection
        title="Book Your Appointment Now"
        description="Get clarity and direction through our astrological consultations."
      />

      <div className="bookingpage-appointment-grid">
        <div className="bookingpage-appointment-left">
          <div className="bookingpage-small-label">Appointment</div>
          <h1 className="bookingpage-hero-heading">
            <span className="line">BOOK</span>
            <span className="line">YOUR</span>
            <span className="line">CONSULTATION</span>
          </h1>
        </div>

        <div className="bookingpage-appointment-right">
          <form className="bookingpage-appointment-form" onSubmit={handlePay}>
            <div className="bookingpage-form-grid">
              {["firstName", "lastName", "phone", "email"].map((field) => (
                <div key={field} className="bookingpage-form-field">
                  <label className="bookingpage-form-label">
                    {field.replace(/^\w/, (c) => c.toUpperCase())}*
                  </label>
                  <input
                    className="bookingpage-form-input"
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                    type={field === "email" ? "email" : "text"}
                    placeholder={`Enter your ${field}`}
                    required
                  />
                </div>
              ))}

              {/* Service Dropdown */}
              <div className="bookingpage-form-field full-width">
                <label className="bookingpage-form-label">Service*</label>
                <div
                  className="bookingpage-dropdown"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <div className="bookingpage-dropdown-selected">
                    {form.service ? (
                      <>
                        <span>{SERVICES[form.service].label}</span>
                        <span className="bookingpage-price-group">
                          <span className="bookingpage-cut-price">
                            ₹{SERVICES[form.service].originalPrice}
                          </span>
                          <span className="bookingpage-offer-price">
                            ₹{SERVICES[form.service].offerPrice}
                          </span>
                        </span>
                      </>
                    ) : (
                      <span>Select your service</span>
                    )}
                  </div>

                  {dropdownOpen && (
                    <div className="bookingpage-dropdown-list">
                      {Object.entries(SERVICES).map(
                        ([key, { label, originalPrice, offerPrice }]) => (
                          <div
                            key={key}
                            className="bookingpage-dropdown-item"
                            onClick={() => {
                              setForm({ ...form, service: key });
                              setDropdownOpen(false);
                            }}
                          >
                            <span>{label}</span>
                            <span className="bookingpage-price-group">
                              <span className="bookingpage-cut-price">₹{originalPrice}</span>
                              <span className="bookingpage-offer-price">₹{offerPrice}</span>
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="bookingpage-form-field full-width">
                <label className="bookingpage-form-label">Date*</label>
                <input
                  className="bookingpage-form-date"
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  required
                />
              </div> */}

              <div className="bookingpage-form-actions">
                <button className="bookingpage-btn-book" type="submit" disabled={!form.service || loading}>
                  {loading ? "Processing..." : `Pay ₹${selectedServicePrice} & Book`}
                </button>
                {message && (
                  <p className={`bookingpage-message ${message.type === "error" ? "error" : "success"}`}>
                    {message.text}
                  </p>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
